import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'redaction'
import actions from 'redux/actions'
import { links, constants } from 'common/helpers'
import { FormattedHTMLMessage } from 'sb-react-intl'

import Modal from 'components/modal/Modal/Modal'
import Button from 'components/buttons/Button/Button'

import messages from './messages'
import s from './SubscriptionUndeliverableModal.scss'

import birdImage from './images/bird@2x.png'


class SubscriptionUndeliverableModal extends Component {

  static propTypes = {
    name: PropTypes.string.isRequired,
    title: PropTypes.object,
    text: PropTypes.object,
    firstName: PropTypes.string,
    isLimitedEditionMode: PropTypes.bool,
    onClose: PropTypes.func,
  }

  static defaultProps = {
    name: constants.modals.SubscriptionUndeliverable,
    title: messages.title,
    text: messages.text,
    firstName: '',
  }

  close = () => {
    const { name, onClose, isLimitedEditionMode } = this.props

    if (!isLimitedEditionMode) {
      actions.models.ui.setClosedPopup(constants.modals.SubscriptionUndeliverable)
    }

    actions.models.modals.close(name)

    if (typeof onClose === 'function') {
      onClose()
    }
  }

  render() {
    const { name, firstName, title, text } = this.props

    return (
      <Modal
        className={s.weMissedYouModal}
        name={name}
        title={title}
        onClose={this.close}
      >
        <div className={s.textContainer}>
          <div className={s.imageBox}>
            <img className={s.birdImage} src={birdImage} alt="" />
          </div>
          <div className={s.messageBox}>
            <FormattedHTMLMessage
              className={s.bold}
              {...messages.firstName}
              values={{ firstName }}
            />
            <FormattedHTMLMessage tag="div" {...text} />
          </div>
        </div>
        <Button
          className={s.button}
          to={links.profile.billingAndShipping}
          title={messages.button}
          onClick={this.close}
          lg
          brand
        />
        <FormattedHTMLMessage className={s.contactInfo} {...messages.contactInfo} />
      </Modal>
    )
  }
}


export default connect({
  firstName: 'models.me.firstName',
})(SubscriptionUndeliverableModal)
